<template>
    <div class="container-fluid pt-2">
        <div v-if="companySettings.hide_orders_from_employees && !canManageOrdersRole && !hasPermission('view-orders')">
            <div class="d-flex justify-content-center align-items-center">
                <div class="text-center">
                    <img src="/images/embarrassed.png" style="width:40px;" class="img-fluid">
                    <h1 class="text-center py-3">Please talk to admin</h1>
                    <hr />
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-3 col-sm-4">
                    <div class="text-left py-3">
                        <h4 class="text-weight-700 text-primary"> Orders</h4>
                    </div>
                </div>
                <div class="col-md-9 col-sm-8">
                    <div class="text-right py-3">
                        <a v-if="canManageOrdersRole" class="btn btn-primary btn-sm px-1" @click="switchOrdersAction">Action on Orders</a>
                        <a v-if="canManageOrdersRole" class="btn btn-outline-primary btn-sm px-1" @click="withDeletedOrders(true)">Include Deleted Orders</a>
                        <a v-if="canManageOrdersRole || hasPermission('can see daily sales breakdown')" class="btn btn-outline-primary btn-sm px-1" v-b-modal="'daily-department-sales-modal'">Daily Sales Analysis</a>
                        <a v-if="canUseQuickDispatch" class="btn btn-outline-primary btn-sm px-1" @click="openQuickScan('dispatch')"><i class="bi bi-upc-scan mr-1"></i>Dispatch</a>
                        <a v-if="canUseQuickReturns" class="btn btn-outline-primary btn-sm px-1" @click="openQuickScan('return')"><i class="bi bi-arrow-counterclockwise mr-1"></i>Return</a>
                    </div>
                </div>
            </div>
            <div class="pt-2">
                <div class="row align-items-start">
                    <div class="col-md-3 col-12 my-1">
                        <form @submit.prevent="completeSearchOrderValue" class="form-inline">
                            <div class="input-group w-100">
                                <input type="text" ref="search_item_focus" class="form-control" v-model="searchOrderValue" placeholder="Order no. or customer name, phone, town…">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="submit">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 col-12 my-1">
                        <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
                            <template #input="picker" style="width: 100% !important;">
                                                                <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                                <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
</template>
                                        </date-range-picker>
                    </div>
                    <div class="col-md-2 col-6 my-1" v-if="hasChannelsEnabled">
                        <select class="form-control" v-model="ordersource" @change="displayOrders()">
                            <option value="">All Channels</option>
                            <option value="0">POS</option>
                            <option value="2">Shopify</option>
                            <option value="1">WooCommerce</option>
                            <option value="3">Payment Link</option>
                        </select>
                    </div>
                    <div class="col-md-2 col-6 my-1" v-if="hasChannelsEnabled">
                        <select class="form-control" v-model="fulfillmentStatusFilter" @change="displayOrders()">
                            <option value="">All Fulfillment</option>
                            <option value="not_released">Not Released</option>
                            <option value="packing">Packing</option>
                            <option value="partially_dispatched">Partially Dispatched</option>
                            <option value="dispatched">Dispatched (Full)</option>
                            <option value="delivered">Delivered</option>
                            <option value="partially_returned">Partially Returned</option>
                            <option value="returned">Returned</option>
                            <option value="cancelled">Cancelled</option>
                        </select>
                    </div>
                    <template v-if="userRole==='Admin' || hasPermission('can manage orders')">
                        <template v-if="showMoreFilters">
                            <div class="col-md-2 col-6 my-1">
                                <select class="form-control" v-model="paymentMethodFilter" @change="displayOrders()">
                                    <option value="">All Payment Methods</option>
                                    <option v-for="pm in paymentMethodOptions" :key="pm.id" :value="pm.id">{{ pm.payment_method || pm.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-2 col-6 my-1">
                                <select class="form-control" v-model="statusFilter" @change="displayOrders()">
                                    <option value="">All Statuses</option>
                                    <option value="completed">Completed</option>
                                    <option value="pending">Pending</option>
                                    <option value="partial">Partial</option>
                                    <option value="has_balance">Has Balance</option>
                                </select>
                            </div>
                            <div class="col-md-2 col-6 my-1">
                                <select class="form-control" v-model="soldByFilter" @change="displayOrders()">
                                    <option value="">All Employees</option>
                                    <option v-for="employee in employees" :key="employee.users.id" :value="employee.users.id">{{ employee.users.name }}</option>
                                </select>
                            </div>
                        </template>
                        <div class="col-auto my-1">
                            <button type="button" class="btn btn-outline-secondary btn-sm" :title="showMoreFilters ? 'Less Filters' : 'More Filters'" @click="showMoreFilters = !showMoreFilters">
                                <i class="bi" :class="showMoreFilters ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                            </button>
                        </div>
                    </template>
                </div>

            </div>
            <div v-if="companySettings.allow_summaries" class="text-center py-3">
            <div class="d-inline">

                    <span v-for="(value,key) in paymentSummary"
                    class="py-2 px-3 badge badge-secondary text-capitalize mx-1"
                >
                    {{ key }} - {{ convertCurrencyToLocal(value) }}
                </span>


            </div>
            </div>


                    <div v-if="orders.length < 1 && isLoadingOrdersDone" >
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="text-center">
                                        <img src="/images/embarrassed.png" style="width:20px;" class="img-fluid">
                                        <p class="text-center py-3">Sorry No Orders Made</p>
                                        <div class="btn-group">
                                            <a href="/orders" class="btn btn-sm mx-1 btn-outline-secondary" >Reload <i class="bi bi-arrow-repeat"></i></a>
                                            <a href="/makesale" class="btn btn-sm mx-1 btn-primary" >Make Sale <i class="bi bi-cart"></i></a>
                                        </div>
                                        <hr />

                                    </div>
                                </div>
                    </div>
                    <div v-else-if="orders.length >= 1 && isLoadingOrdersDone " >
                                <div v-if="ordersToAction.selected.length > 0">
                                    <div class="d-inline">
                                        <a v-if="ordersToAction.allSelected===false" @click="selectAllRows" class="btn btn-secondary btn-sm">Select All</a>
                                        <a v-else @click="clearSelected" class="btn btn-outline-secondary btn-sm">Unselect All</a>
                                        <a v-b-modal="'change-order-date'" class="btn btn-primary btn-sm">Change Order Date</a>
                                        <a v-if="userRole==='Admin' || hasPermission('can manage orders')" v-b-modal="'delete-many-orders'" class="btn btn-danger btn-sm">Delete</a>

                                    </div>

                                </div>

                            <b-table
                            v-if="ordersToAction.changeToSelection === false"
                            striped
                                 hover
                                 small
                                 sticky-header="90vh"
                                 :items="items"
                                 :fields="fields"
                                 sort-icon-left
                                 responsive="sm"
                                 class="text-sm"
                                 :tbody-tr-class="ordersRowClass"
                                @row-clicked="onRowClicked">

<template #cell(#)="data">
    <div class="d-inline">
        <p v-if="data.item.status === 1" title="Completed" class="underline-primary" style="display: flex; align-items: center;">
            <span class="text-success text-sm circle-icon-success">
                    <i class="bi bi-check-lg"></i>
                </span> &nbsp;
            <span v-if="data.item.is_verified" class="text-success text-sm circle-icon-success">
                    <i class="bi bi-check-lg"></i>
                 </span>
        </p>
        <p v-else-if="data.item.total_amount !== data.item.balance && data.item.balance > 0" title="Has balance" class="text-dark" style="display: flex; align-items: center;">
            <span class="text-danger circle-icon-warning">
                    <i class="bi bi-circle-half"></i>
                </span>
        </p>
        <p v-else title="Pending payment" class="text-dark" style="display: flex; align-items: center;">
            <span class="text-danger circle-icon-danger">
                    <i class="bi bi-hourglass-split"></i>
                 </span>
        </p>
        <div v-if="data.item.kitchenorders && data.item.kitchenorders.length" class="mt-1">
            <p class="text-capitalize mb-1 text-muted ">Kitchen status</p>
            <div v-for="kds in data.item.kitchenorders" :key="kds.id" class="d-flex align-items-center mb-1">
                <i class="bi bi-circle-fill mr-1" :class="getStatusColor(kds.status)" :title="kds.status"></i>
                <small class="text-capitalize text-muted">{{ kds.prep_station || 'General' }}</small>
            </div>
        </div>

        <!-- Print indicator -->
        <div v-if="data.item.print_logs_count > 0" class="mt-1 d-flex align-items-center">
            <i
                class="bi mr-1"
                :class="data.item.print_logs_count > 1 ? 'bi-printer-fill text-warning' : 'bi-printer text-secondary'"
                :title="data.item.print_logs_count + ' print(s)'"
            ></i>
            <small class="text-muted">{{ data.item.print_logs_count }}×</small>
        </div>

    </div>
</template>


<template #cell(order)="data">
    <p>
        {{ data.item.order }}
    </p>
    <hr class="m-0" />
    <p>
        <small v-if="data.item && data.item.soldby && data.item.soldby.name" class="text-capitalize">
                                                                 {{ data.item.soldby.name }}
                                                            </small>
    </p>
</template>

<template #cell(created_at)="data">
    <p> {{ formatDate(data.item.created_at,'HH:mm A - DD MMM Y') }}</p>
</template>



<template #cell(total_amount)="data">
    <p> {{convertCurrencyToShillings(data.item.total_amount) }}</p>
</template>

<template #cell(payment_method)="data">
  <div style="min-width:120px">
    <!-- Single payment method -->
    <div v-if="data.item.paymentmethod && data.item.paymentmethod !== ''">
      <span :class="['badge text-capitalize', getPaymentBadgeClass(data.item.paymentmethod.payment_method)]" :title="data.item.bnpl_exists ? 'Originally sold on BNPL' : null">
        {{ data.item.bnpl_exists ? 'BNPL · ' : '' }}{{ data.item.paymentmethod.payment_method }}
      </span>
      <template v-if="getOrderValidation(data.item)">
        <div v-if="getOrderValidation(data.item).transaction_validated" class="mt-1">
          <small class="text-muted d-block">Ref: <span class="font-weight-bold">{{ getOrderValidation(data.item).transaction_validated.transaction_code }}</span></small>
          <span :class="['badge badge-sm', validationStatusClass(getOrderValidation(data.item).payment_validation_status)]" style="font-size:0.65rem">
            {{ validationStatusLabel(getOrderValidation(data.item).payment_validation_status) }}
          </span>
        </div>
        <div v-else class="mt-1">
          <span :class="['badge badge-sm', validationStatusClass(getOrderValidation(data.item).payment_validation_status)]" style="font-size:0.65rem">
            {{ validationStatusLabel(getOrderValidation(data.item).payment_validation_status) }}
          </span>
        </div>
      </template>
    </div>

    <!-- Split payments -->
    <div v-else-if="getOrderPaymentLegs(data.item).length > 0">
      <div v-for="(leg, idx) in getOrderPaymentLegs(data.item)" :key="idx" class="mb-1">
        <span :class="['badge text-capitalize', getPaymentBadgeClass(leg.payment_method)]" :title="(idx === 0 && data.item.bnpl_exists) ? 'Originally sold on BNPL' : null">
          {{ (idx === 0 && data.item.bnpl_exists) ? 'BNPL · ' : '' }}{{ leg.payment_method }}
        </span>
        <div v-if="leg.transaction_validated" class="mt-1">
          <small class="text-muted d-block">Ref: <span class="font-weight-bold">{{ leg.transaction_validated.transaction_code }}</span></small>
          <span :class="['badge badge-sm', validationStatusClass(leg.payment_validation_status)]" style="font-size:0.65rem">
            {{ validationStatusLabel(leg.payment_validation_status) }}
          </span>
        </div>
        <div v-else-if="leg.payment_validation_status && leg.payment_validation_status !== 'not_required'" class="mt-1">
          <span :class="['badge badge-sm', validationStatusClass(leg.payment_validation_status)]" style="font-size:0.65rem">
            {{ validationStatusLabel(leg.payment_validation_status) }}
          </span>
        </div>
      </div>
    </div>

    <!-- BNPL with no deposit: no payment recorded yet (since 2026-08-03 a
         zero deposit no longer creates a fake 0-amount "BNPL" leg), so say so. -->
    <div v-else-if="data.item.bnpl_exists">
      <span class="badge badge-dark" title="Buy Now Pay Later - nothing paid yet">BNPL</span>
    </div>

    <!-- Loyalty points redeemed — shown separately from the money legs
         above; points are never merged into the payment/split legs. -->
    <div v-if="data.item.loyalty_redemption" class="mt-1">
      <span class="badge badge-primary">
        <i class="bi bi-star"></i> {{ data.item.loyalty_redemption.points_redeemed }} pts
      </span>
    </div>
  </div>
</template>

<template #cell(source)="data">
  <span :class="['badge text-capitalize', sourceBadgeClass(data.item.source)]">{{ sourceLabel(data.item.source) }}</span>
</template>

<template #cell(fulfillment_status)="data">
  <span v-if="data.item.source === 1 || data.item.source === 2" :class="['badge', fulfillmentBadgeClass(data.item.fulfillment_status)]">
    {{ fulfillmentLabel(data.item.fulfillment_status) }}
  </span>
  <span v-else class="text-muted">—</span>
  <small v-if="orderAddressLine(data.item)" class="d-block text-muted mt-1" style="max-width:180px;line-height:1.2;">
    <i class="bi bi-geo-alt"></i> {{ orderAddressLine(data.item) }}
  </small>
</template>

                            </b-table>
                            <b-table
                            v-else
                            striped
                                 hover
                                 small
                                 sticky-header="90vh"
                                 :items="items"
                                 :fields="fields"
                                 sort-icon-left
                                 responsive="sm"
                                 class="text-sm"
                                 :select-mode="ordersToAction.selectMode"
                                ref="selectableTable"
                                selectable
                                @row-selected="onRowSelected"
                                >

<template #cell(#)="{ rowSelected }">
    <template v-if="rowSelected">
                                                <span aria-hidden="true">&check;</span>
                                                <span class="sr-only">Selected</span>
</template>

<template v-else>
    <span aria-hidden="true">&#x25a2;</span>
    <span class="sr-only">Not selected</span>
</template>
                                </template>


<template #cell(order)="data">
    <p>
        {{ data.item.order }}
    </p>
</template>

<template #cell(created_at)="data">
    <p> {{ formatDate(data.item.created_at,'HH:MM A - DD MMM Y') }}</p>
</template>



<template #cell(total_amount)="data">
    <p> {{convertCurrencyToShillings(data.item.total_amount) }}</p>
</template>

<template #cell(payment_method)="data">
    <!-- <p v-if="data.item.paymentmethod"> {{ data.item.paymentmethod.payment_method }}</p> -->
    <p v-if="data.item.paymentmethod && data.item.paymentmethod !==''">
        <span type="button" :class="{'badge badge-secondary text-capitalize mx-1': data.item.paymentmethod.payment_method === 'Cash', 'badge badge-primary text-capitalize mx-1': data.item.paymentmethod.payment_method !== 'Cash'}" :title="data.item.bnpl_exists ? 'Originally sold on BNPL' : null">
                                                                {{ data.item.bnpl_exists ? 'BNPL · ' : '' }}{{ data.item.paymentmethod.payment_method }}
                                                             </span>
    </p>
    <p v-else-if="getOrderPaymentLegs(data.item).length > 0">
        <span type="button" v-for="(leg, idx) in getOrderPaymentLegs(data.item)" :class="['badge', 'text-capitalize', 'mx-1', getPaymentBadgeClass(leg.payment_method)]" :title="(idx === 0 && data.item.bnpl_exists) ? 'Originally sold on BNPL' : null">
            {{ (idx === 0 && data.item.bnpl_exists) ? 'BNPL · ' : '' }}{{ leg.payment_method }}
        </span>
    </p>
    <p v-else-if="data.item.bnpl_exists">
        <span class="badge badge-dark mx-1" title="Buy Now Pay Later - nothing paid yet">BNPL</span>
    </p>
    <p v-if="data.item.loyalty_redemption">
        <span class="badge badge-primary mx-1"><i class="bi bi-star"></i> {{ data.item.loyalty_redemption.points_redeemed }} pts</span>
    </p>
</template>

<template #cell(source)="data">
  <span :class="['badge text-capitalize', sourceBadgeClass(data.item.source)]">{{ sourceLabel(data.item.source) }}</span>
</template>

<template #cell(fulfillment_status)="data">
  <span v-if="data.item.source === 1 || data.item.source === 2" :class="['badge', fulfillmentBadgeClass(data.item.fulfillment_status)]">
    {{ fulfillmentLabel(data.item.fulfillment_status) }}
  </span>
  <span v-else class="text-muted">—</span>
  <small v-if="orderAddressLine(data.item)" class="d-block text-muted mt-1" style="max-width:180px;line-height:1.2;">
    <i class="bi bi-geo-alt"></i> {{ orderAddressLine(data.item) }}
  </small>
</template>

                            </b-table>
                                <nav aria-label="Page navigation example" class="float-right mb-5">
                                    <ul class="pagination">
                                        <li class="page-item"><button class="page-link" href="#" v-if="this.current_page !== this.first_page" @click="prevPage"><i class="fas fa-chevron-left"></i><i class="fas fa-chevron-left"></i> &nbsp;Previous</button></li>
                                        <li class="page-item"><button class="page-link disabled" href="#">{{ this.current_page }}</button></li>
                                        <li class="page-item"><button class="page-link" href="#" @click="nextPage" v-if="this.current_page !== this.last_page">Next &nbsp;<i class="fas fa-chevron-right"></i><i class="fas fa-chevron-right"></i></button></li>
                                    </ul>
                                </nav>


                    </div>
                <div v-else>
                    <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>

                </div>

                </div>





               <b-modal ref="orderDetailsModal" size="lg" hide-footer>

                <div class="text-center" v-if="orderToShow">
                    <h2  v-if="orderToShow.status === 0">
                        <span class="text-danger" v-if="orderToShow.partial===1">
                            <i class="bi bi-circle-half"></i>
                            <span>
                                        Partial
                            </span>
                        </span>
                        <span v-else>
                            <i class="bi bi-exclamation-diamond"></i>
                                    <span>
                                        Pending
                                     </span>
                        </span>

                                    </h2>
                                    <h2 class="text-success" v-else>
                                        <i class="bi bi-check2-circle"></i>
                                        <i v-if="orderToShow.is_verified" class="bi bi-check2-circle"></i>

                                    <span>
                                 Completed
                                     </span>
                                    </h2>
                                    <hr />

                        <h6 class="font-weight-bold">
                            Order No:  &nbsp; {{orderToShow.order}}
                            <span v-if="orderToShow.bnpl_exists" class="badge badge-dark font-weight-normal ml-1" style="font-size:0.65rem; vertical-align:middle;" title="Originally sold on BNPL">
                                <i class="bi bi-hourglass-split"></i>&nbsp;BNPL
                            </span>
                        </h6>
                        <p class="py-1">Time:&nbsp; <span class="font-weight-bold">{{formatDate(orderToShow.created_at,'hh:mm A')}}</span></p>
                        <p class="py-1">Date:&nbsp; <span class="font-weight-bold">{{formatDate(orderToShow.created_at,'DD-MMM-YYYY')}}</span></p>
                        <p v-if="orderToShow.soldby" class="py-1">Order by:&nbsp  <span class="font-weight-bold text-capitalize">{{orderToShow.soldby.name}}</span></p>
                        <p v-if="orderToShow.source === 1 || orderToShow.source === 2" class="py-1">
                            Channel:&nbsp;
                            <span :class="['badge text-capitalize', sourceBadgeClass(orderToShow.source)]">{{ sourceLabel(orderToShow.source) }}</span>
                            &nbsp;
                            <span :class="['badge', fulfillmentBadgeClass(orderToShow.fulfillment_status)]">{{ fulfillmentLabel(orderToShow.fulfillment_status) }}</span>
                        </p>
                        <a v-if="canPackDispatch(orderToShow)"
                           href="#" @click.prevent="openPackDispatch(orderToShow.id)" class="btn btn-link btn-sm p-0 d-block mb-2">
                            <i class="bi bi-box-seam mr-1"></i>Pack / Dispatch
                        </a>
                        <p class="py-1" v-if="orderToShow.deleted_at && orderToShow.deletedby">Deleted By:&nbsp; {{ orderToShow.deletedby.name }}</p>
                        <p class="py-1" v-if="orderToShow.deleted_at">Deleted on:&nbsp; <small>{{formatDate(orderToShow.deleted_at,'hh:mm A DD-MMM-YYYY')}}</small></p>
                        <p v-if="orderToShow.status === 1 && orderToShow.partial === 0 && orderToShow.paymentmethod" class="py-1">
                            Payment:&nbsp; <span class="font-weight-bold text-capitalize">{{orderToShow.paymentmethod.payment_method}}</span>
                            <button v-if="canManagePayments()" @click="openEditPaymentModal(null)" class="btn btn-link btn-sm p-0 ml-1" title="Change payment method"><i class="bi bi-pencil"></i></button>
                        </p>

                        <!-- Payment validation detail block (single-payment orders only) -->
                        <template v-if="orderToShow.paymentmethod && getOrderPaymentLegs(orderToShow).length <= 1 && getOrderValidation(orderToShow)">
                          <div class="border rounded p-2 mt-2 mb-2" style="background:#f8f9fa">
                            <p class="mb-1 font-weight-bold text-muted text-uppercase" style="font-size:0.7rem;letter-spacing:.05em">Payment Validation</p>

                            <div class="d-flex align-items-center mb-1">
                              <span :class="['badge mr-2', validationStatusClass(getOrderValidation(orderToShow).payment_validation_status)]">
                                {{ validationStatusLabel(getOrderValidation(orderToShow).payment_validation_status) }}
                              </span>
                              <small v-if="getOrderValidation(orderToShow).payment_validated_at" class="text-muted">
                                {{ formatDate(getOrderValidation(orderToShow).payment_validated_at, 'DD MMM YYYY HH:mm') }}
                              </small>
                            </div>

                            <template v-if="getOrderValidation(orderToShow).transaction_validated">
                              <p class="mb-0">Reference: <span class="font-weight-bold">{{ getOrderValidation(orderToShow).transaction_validated.transaction_code }}</span></p>
                              <p class="mb-0">Amount: <span class="font-weight-bold">{{ convertCurrencyToShillings(getOrderValidation(orderToShow).transaction_validated.amount) }}</span></p>
                              <p v-if="getOrderValidation(orderToShow).transaction_validated.customer" class="mb-0">Sender: <span class="font-weight-bold">{{ getOrderValidation(orderToShow).transaction_validated.customer }}</span></p>
                              <p v-if="getOrderValidation(orderToShow).payment_validation_method" class="mb-0">Source: <span class="font-weight-bold text-capitalize">{{ getOrderValidation(orderToShow).payment_validation_method === 'sms' ? 'SMS Validator App' : (getOrderValidation(orderToShow).payment_validation_method === 'stk' ? 'M-Pesa Prompt' : (getOrderValidation(orderToShow).payment_validation_method === 'c2b' ? 'Paybill (C2B)' : getOrderValidation(orderToShow).payment_validation_method)) }}</span></p>
                              <p v-if="getOrderValidation(orderToShow).transaction_validated.assigned_by" class="mb-0">Validated by: <span class="font-weight-bold">{{ getOrderValidation(orderToShow).transaction_validated.assigned_by.name }}</span></p>
                            </template>

                            <!-- Override info -->
                            <template v-if="getOrderValidation(orderToShow).payment_validation_status === 'override'">
                              <hr class="my-1"/>
                              <p class="mb-0 text-warning font-weight-bold"><i class="bi bi-exclamation-triangle"></i> Validation Override</p>
                              <p v-if="orderToShow.paymentOverride" class="mb-0">Reason: {{ orderToShow.paymentOverride.reason }}</p>
                              <p v-if="orderToShow.paymentOverride && orderToShow.paymentOverride.approvedBy" class="mb-0">Approved by: <span class="font-weight-bold">{{ orderToShow.paymentOverride.approvedBy.name }}</span></p>
                            </template>
                          </div>
                        </template>
                      <a class="btn btn-outline-danger btn-sm "  v-if="canManageOrdersRole && orderToShow.deleted_at" @click="unDeleteOrderConfirm(orderToShow)" >Restore Order</a>


                    <div v-if="getOrderPaymentLegs(orderToShow).length > 0" class="mt-1">
                      <div v-for="leg in getOrderPaymentLegs(orderToShow)" :key="leg.id" class="border rounded p-2 mb-1" style="background:#f8f9fa">
                        <div class="d-flex justify-content-between align-items-center">
                          <span class="font-weight-bold text-capitalize">
                            {{ leg.payment_method }}
                            <button v-if="canManagePayments()" @click="openEditPaymentModal(leg)" class="btn btn-link btn-sm p-0 ml-1" title="Change payment method"><i class="bi bi-pencil"></i></button>
                          </span>
                          <span>{{ convertCurrencyToShillings(leg.paid_amount) }}</span>
                        </div>
                        <small v-if="leg.created_at" class="text-muted d-block">{{ formatDate(leg.created_at, 'DD MMM YYYY, hh:mm A') }}</small>
                        <template v-if="leg.transaction_validated">
                          <small class="text-muted d-block">Ref: <span class="font-weight-bold">{{ leg.transaction_validated.transaction_code }}</span></small>
                          <small class="text-muted d-block">Amount: {{ convertCurrencyToShillings(leg.transaction_validated.amount) }}</small>
                          <small v-if="leg.transaction_validated.customer" class="text-muted d-block">Sender: {{ leg.transaction_validated.customer }}</small>
                          <small v-if="leg.transaction_validated.assigned_by" class="text-muted d-block">Validated by: {{ leg.transaction_validated.assigned_by.name }}</small>
                          <span :class="['badge badge-sm mt-1', validationStatusClass(leg.payment_validation_status)]" style="font-size:0.65rem">
                            {{ validationStatusLabel(leg.payment_validation_status) }}
                          </span>
                        </template>
                        <template v-else-if="leg.payment_validation_status && leg.payment_validation_status !== 'not_required'">
                          <span :class="['badge badge-sm mt-1', validationStatusClass(leg.payment_validation_status)]" style="font-size:0.65rem">
                            {{ validationStatusLabel(leg.payment_validation_status) }}
                          </span>
                        </template>
                      </div>
                    </div>

                    <!-- Loyalty points redeemed — a separate box, not a
                         payment leg: points aren't money, so this stays out
                         of getOrderPaymentLegs()/the SplitOrderPayment/Payment
                         totals entirely, but must still be visible here so
                         cash + points visibly cover the order total. -->
                    <div v-if="orderToShow.loyalty_redemption" class="mt-1">
                      <div class="border rounded p-2 mb-1" style="background:#f8f9fa">
                        <div class="d-flex justify-content-between align-items-center">
                          <span class="font-weight-bold"><i class="bi bi-star text-primary"></i> Points Redeemed</span>
                          <span>{{ orderToShow.loyalty_redemption.points_redeemed }} pts</span>
                        </div>
                        <small class="text-muted d-block">{{ convertCurrencyToShillings(orderToShow.loyalty_redemption.discount_value) }} off</small>
                      </div>
                    </div>
                        <!-- Customer: every detail we hold, incl. where to deliver -->
                        <div class="text-left border rounded p-3 mb-2" v-if="customer" style="border-color:#e9ecef !important;">
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <span class="text-dark" style="font-weight:600;font-size:14px;"><i class="bi bi-person mr-1 text-secondary"></i>{{ customer.full_name || 'Customer' }}</span>
                          </div>
                          <div class="row" style="row-gap:8px;font-size:13px;">
                            <div class="col-6" v-if="customer.phone">
                              <div class="text-secondary" style="font-size:12px;">Phone</div>
                              <a :href="'tel:' + customer.phone" class="text-dark">{{ customer.phone }}</a>
                            </div>
                            <div class="col-6" v-if="customer.email">
                              <div class="text-secondary" style="font-size:12px;">Email</div>
                              <a :href="'mailto:' + customer.email" class="text-dark text-break">{{ customer.email }}</a>
                            </div>
                            <div class="col-6" v-if="customer.company">
                              <div class="text-secondary" style="font-size:12px;">Company</div>
                              <div class="text-dark">{{ customer.company }}</div>
                            </div>
                            <div class="col-6" v-if="customer.krapin">
                              <div class="text-secondary" style="font-size:12px;">KRA PIN</div>
                              <div class="text-dark">{{ customer.krapin }}</div>
                            </div>
                            <div class="col-12" v-if="customer.address_address">
                              <div class="text-secondary" style="font-size:12px;">Street / location</div>
                              <div class="text-dark">{{ customer.address_address }}</div>
                            </div>
                            <div class="col-6" v-if="customer.apartment">
                              <div class="text-secondary" style="font-size:12px;">House / apartment</div>
                              <div class="text-dark">{{ customer.apartment }}</div>
                            </div>
                            <div class="col-6" v-if="customer.town">
                              <div class="text-secondary" style="font-size:12px;">Town</div>
                              <div class="text-dark">{{ customer.town }}</div>
                            </div>
                            <div class="col-12" v-if="customerMapUrl">
                              <a :href="customerMapUrl" target="_blank" rel="noopener" class="text-primary" style="font-size:12px;font-weight:600;"><i class="bi bi-geo-alt mr-1"></i>Open location in Maps</a>
                            </div>
                            <div class="col-12 text-secondary" style="font-size:12px;" v-if="!customer.phone && !customer.email && !customer.full_address">
                              No contact or address details saved for this customer.
                            </div>
                          </div>
                        </div>
                        </div>
                            <div class="text-left" v-if="orderToShow.deleted_at ===null">


                                <div class="pt-1 pb-2" v-if="orderToShow.status === 0  && orderToShow.partial === 0">


                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div v-if="companySettings.has_kds" class="d-inline">

                                                <a v-if="(userRole==='Admin' || hasPermission('can manage orders') || hasPermission('view-orders'))" :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-block btn-primary">Complete Order</a>
                                                <a v-else :href='"/print_invoice/" + orderToShow.id'  class="btn btn-block btn-outline-secondary">Print Customer Receipt</a>
                                            </div>
                                            <div v-else class="d-inline">

                                                <a :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-block btn-primary">Complete Order</a>
                                            </div>

                                        </div>
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div class="dropdown">
                                                <a class="btn btn-outline-secondary btn-block dropdown-toggle"  type="button" data-toggle="dropdown" aria-expanded="false">
                                                     More ...
                                                </a>
                                                <div class="dropdown-menu">

                                                    <a :href='"makesale?add-to-order=" + orderToShow.id'  class="dropdown-item">Add More Items </a>
                                                    <a :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                                    <a v-if="companySettings.has_kds" :href='"/print_invoice/" + orderToShow.id + "?order-receipt=true"'  class="dropdown-item">Print Kitchen Order</a>

                                                    <a :href='"/customer-order-view/" + orderToShow.id'  class="dropdown-item">View Receipt</a>
                                                    <a style="color: #28D146;" target="_blank"  v-if="customer && customer.phone" :href='"https://wa.me/" + convertToInternational(customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ encodeURIComponent(userDetails.company?.name || "") +"%20" + $platformBrand.appUrl + "/customer-order-view/" + orderToShow.id + "?from=whatsapp&utm=whatsapp"'  class="dropdown-item"><i class="bi bi-whatsapp"></i>&nbsp Share via whatsapp</a>
                                                    <a v-if="orderToShow.balance > 0" href="#" @click.prevent="$refs.sharePaymentLink.open(orderToShow, customer)" class="dropdown-item">Share Payment Link</a>

                                                    <a v-if="customer && customer.phone" v-b-modal="'textmessage-modal'" href="#" class="dropdown-item">Send SMS</a><div class="dropdown-divider"></div>

                                                    <a class="dropdown-item text-danger"  v-if="canRemoveFrom(orderToShow) && (!orderToShow.deleted_at)" @click="deleteOrderConfirm(orderToShow)" >Delete Order</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="pt-1 pb-2" v-if="orderToShow.status === 1 || orderToShow.partial === 1">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div v-if="orderToShow.partial === 1 && orderToShow.status===0">

                                                <a v-if="(userRole==='Admin' || !hasPermission('can complete order'))" :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-primary btn-outline-primary btn-block">Complete Order</a>
                                                  <a v-else :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                            </div>
                                            <div v-else>
                                                <a :href='"/print_invoice/" + orderToShow.id'  class="btn btn-block btn-primary">Print Receipt</a>
                                            </div>
                                        </div>
                                    <div class="col-sm-6 col-md-6 col-6">
                                        <div class="dropdown">
                                            <a class="btn btn-outline-secondary btn-block dropdown-toggle"  type="button" data-toggle="dropdown" aria-expanded="false">
                                            More ...
                                            </a>
                                            <div class="dropdown-menu">
                                                <!-- <a v-if="orderToShow.partial === 1" :href='"makesale?add-to-order=" + orderToShow.id'  class="dropdown-item">Add More Items </a> -->
                                                <a v-if="orderToShow.partial === 1 && orderToShow.status===0" :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                                <a style="color: #28D146;" target="_blank"  v-if="customer && customer.phone" :href='"https://wa.me/" + convertToInternational(customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ encodeURIComponent(userDetails.company?.name || "") +"%20" + $platformBrand.appUrl + "/customer-order-view/" + orderToShow.id + "?from=whatsapp&utm=whatsapp"'  class="dropdown-item"><i class="bi bi-whatsapp"></i>&nbsp Share via whatsapp</a>
                                                <a :href='"/customer-order-view/" + orderToShow.id'  class="dropdown-item">View Receipt</a>
                                                <a v-if="orderToShow.balance > 0" href="#" @click.prevent="$refs.sharePaymentLink.open(orderToShow, customer)" class="dropdown-item">Share Payment Link</a>
                                                <a  href="#" v-if="companySettings.has_order_verification && orderToShow.is_verified === 0" @click="markOrderasVerified(orderToShow.id)" class="dropdown-item">Mark as Collected</a>

                                                <a v-if="customer && customer.phone" v-b-modal="'textmessage-modal'" href="#" class="dropdown-item">Send SMS</a>

                                                <a v-else @click="customerModalOpen" href="#" class="dropdown-item">Assign To Customer</a><div class="dropdown-divider"></div>

                                                <a class="dropdown-item text-danger"  v-if="canRemoveFrom(orderToShow) && (!orderToShow.deleted_at)" @click="deleteOrderConfirm(orderToShow)" >Delete Order</a>

                                            </div>
                                        </div>
                                    </div>
                                    </div>

                                </div>

                            </div>






                    <hr/>
                    <div class="text-left">
                        <h5>
                            Product order list
                        </h5>
                    </div>

    <table class="table table-hover">
      <thead>
        <td>#</td>
        <td>Item</td>
        <td>Qty</td>
        <td v-if="canSeeProfit">Profits</td>
        <td>Amount</td>
        <td class="text-nowrap text-right" colspan="1">Options</td>
      </thead>

      <tbody>
        <tr v-if="orderItem.product || orderItem.grouped_inventory"
            v-for="(orderItem, index) in orderToShow.orders"
            :key="orderItem.id">

          <td>
            <h6>{{ index + 1 }}</h6>
          </td>

          <!-- Grouped Inventory Item -->
          <td v-if="orderItem.grouped_inventory">
            <h6>{{ orderItem.grouped_inventory.group_title }}</h6>
            <hr class="m-0">
            <p v-if="orderItem.grouped_inventory.grouped_items"
               v-for="g_item in orderItem.grouped_inventory.grouped_items"
               :key="g_item.id">
              <small v-if="g_item.product">
                <span v-if="g_item.product.can_be_sold">
                  {{ g_item.product.product }} - {{ g_item.count }}
                </span>
              </small>
              <small v-else class="text-danger">Item could be missing</small>
            </p>
          </td>

          <!-- Regular Product Item -->
          <td v-else>
            <div v-if="orderItem.product.deleted_at">
              <h6 class="text-danger">{{ orderItem.product.product }}</h6>
              <span class="text-danger">**Deleted**</span>
            </div>
            <div v-else>
              <h6>{{ orderItem.product.product }}</h6>
              <div v-if="orderItem.sold_by">
                <hr class="my-1"/>
                <small>{{ orderItem.sold_by.name }}</small>
              </div>
            </div>
          </td>

          <!-- Quantity -->
          <td>
            <h6>{{ orderItem.qty }}</h6>
          </td>

          <!-- 🔥 FIXED: Profits (Tax-Aware) -->
          <td v-if="canSeeProfit">
            <h6 class="text-primary">
              {{ convertCurrencyToLocal(getDisplayProfit(orderItem)) }}
            </h6>
          </td>

          <!-- Amount (Retail) -->
          <td v-if="orderItem.is_retail === 1">
            <h6 v-if="orderItem.product">
              {{ orderItem.qty * ((orderItem.selling_price !== null) ? orderItem.selling_price : orderItem.product.ppu) }}
            </h6>
            <h6 v-else>
              {{ orderItem.qty * orderItem.grouped_inventory.cost }}
            </h6>
          </td>

          <!-- Amount (Wholesale) -->
          <td v-else-if="orderItem.is_retail === 0">
            <h6 v-if="orderItem.product">
              {{ orderItem.qty * ((orderItem.selling_price !== null) ? orderItem.selling_price : orderItem.product.wholesale_sp) }}
            </h6>
            <h6 v-else>
              {{ orderItem.qty * orderItem.grouped_inventory.wholesale }}
            </h6>
          </td>

          <!-- Actions Menu -->
          <td class="text-nowrap text-right" colspan="1">
            <div class="dropdown">
                <a href="#" data-toggle="dropdown" data-boundary="viewport" aria-expanded="false" class="btn btn-sm btn-link p-0">
                <i class="bi bi-three-dots-vertical"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right" v-if="canManageOrdersRole || canRemoveFrom(orderToShow)">
                        <a class="dropdown-item"
                            v-if="(!orderToShow.deleted_at) && canManageOrdersRole"
                            v-b-modal="'re-assign-order'"
                            @click="order_to_assign.orderId = orderItem.id">
                            Re-assign
                        </a>
                        <a class="dropdown-item text-danger"
                            v-if="(!orderToShow.deleted_at) && (orderToShow.partial === 0 && orderToShow.status===0)"
                            @click="deleteSingleOrder(orderItem.id)">
                            Remove Item
                        </a>
                        <a class="dropdown-item text-danger"
                            v-if="(!orderToShow.deleted_at) && (orderToShow.partial === 1 || orderToShow.status===1)"
                            @click="returnItemsModal(orderItem)">
                            Return Item
                        </a>
                        <a class="dropdown-item text-dark"
                            v-if="companySettings.has_kds"
                            @click="sendItemToKitchen(orderItem.id)">
                            Send To Kitchen
                        </a>
                        <a class="dropdown-item text-success"
                            v-if="companySettings.has_kds"
                            @click="markKDSItemAsDone(orderItem.id)">
                            Kitchen Done
                        </a>
                </div>
            <div class="dropdown-menu dropdown-menu-right" v-else>
              <a class="dropdown-item text-dark"
                 v-if="companySettings.has_kds"
                 @click="sendItemToKitchen(orderItem.id)">
                Send To Kitchen
              </a>
              <a class="dropdown-item text-success"
                 v-if="companySettings.has_kds && orderItem.kitchen_status !=='done'"
                 @click="markKDSItemAsDone(orderItem.id)">
                Kitchen Done
              </a>
            </div>
            </div>
          </td>
        </tr>

        <tr v-else>
          <td>#</td>
          <td>
            <p class="text-danger">
              <small>Seems the item sold was deleted from inventory</small>
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 🔥 FIXED: Totals Table with Tax Breakdown -->
    <table class="table table-hover">
      <tbody>
        <!-- Total Quantity -->
        <tr>
          <td class="text-left">
            <h6 class="py-1">All Item/Services</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-dark">{{ totalQuantityComputed }}</h5>
          </td>
        </tr>

        <!-- 🔥 NEW: Subtotal (Net Amount) -->
        <tr v-if="companySettings.enable_taxes">
          <td class="text-left">
            <h6 class="py-1">Sub Total</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-dark">{{ convertCurrencyToLocal(correctSubTotal) }}</h5>
          </td>
        </tr>

        <!-- 🔥 NEW: Tax Breakdown -->
        <tr v-if="companySettings.enable_taxes && orderToShow.tax_ledgers"
            v-for="tax in orderToShow.tax_ledgers"
            :key="tax.id">
          <td class="text-left">
            <h6 class="py-1">{{ tax.description }}</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-dark">{{ convertCurrencyToLocal(tax.credit) }}</h5>
          </td>
        </tr>

        <!-- 🔥 FIXED: Profits (Tax-Aware) -->
        <tr v-if="canSeeProfit">
          <td class="text-left">
            <h6 class="py-1">Profits</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-success">
              {{ convertCurrencyToLocal(correctTotalProfits) }}
            </h5>
          </td>
        </tr>

        <!-- Discount -->
        <tr v-if="orderToShow.discount !== null">
          <td class="text-left">
            <h6 class="py-1">Discount</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-dark">{{ convertCurrencyToLocal(orderToShow.discount) }}</h5>
          </td>
        </tr>

        <!-- Points Redeemed -->
        <tr v-if="orderToShow.loyalty_redemption">
          <td class="text-left">
            <h6 class="py-1">Points Redeemed ({{ orderToShow.loyalty_redemption.points_redeemed }} pts)</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-primary">{{ convertCurrencyToLocal(orderToShow.loyalty_redemption.discount_value) }}</h5>
          </td>
        </tr>

        <!-- Balance -->
        <tr v-if="orderToShow.balance > 0 && !orderToShow.status">
          <td class="text-left">
            <h6 class="py-1">Balance</h6>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-success">{{ convertCurrencyToLocal(orderToShow.balance) }}</h5>
          </td>
        </tr>

        <!-- Grand Total -->
        <tr>
          <td class="text-left">
            <h5 class="py-1">Grand Total</h5>
          </td>
          <td class="text-right">
            <h5 class="py-1 text-primary font-weight-bold">
              {{ convertCurrencyToLocal(orderToShow.total_amount) }}
            </h5>
          </td>
        </tr>
      </tbody>
    </table>



                            <hr />
                            <div class="container">
                                <div class="float-right">
                                <b-button v-b-modal.modal-5 variant="outline-primary" size="sm"  >Add a Note &nbsp; <i class="bi bi-pencil"></i></b-button>
                            </div>
                            </div>


                            <h5>Notes</h5>
                            <ul class="list-unstyled">
                                <li v-if="note && note.user" class="py-2 px-1 border" v-for="note in orderToShow.ordernotes"><span class="text-capitalize">{{ note.user.name }} - </span>{{ note.note }} &nbsp; <a @click="deleteOrderNote(note.id)" class="text-danger float-right"><i class="bi bi-trash3"></i></a></li>
                            </ul>

                             <hr />

               </b-modal>
               <b-modal ref="packDispatchModal" size="lg" title="Pack / Dispatch" hide-footer>
                    <pack-dispatch v-if="fulfillmentOrderId" :order-id="fulfillmentOrderId" :tracking-enabled="!!companySettings.enable_courier_tracking" @updated="onPackDispatchUpdated"></pack-dispatch>
               </b-modal>
               <b-modal ref="quickScanModal" :title="quickScanMode === 'dispatch' ? 'Dispatch — Scan Items' : 'Return — Scan Items'" hide-footer @shown="focusQuickScanInput">
                    <small class="text-muted d-block mb-2" v-if="quickScanMode === 'dispatch'">
                        Scan an order's own barcode to dispatch it in full, or scan a product to check it off whichever open order needs it.
                    </small>
                    <small class="text-muted d-block mb-2" v-else>
                        Scan a product being physically returned — it's matched against whichever dispatched order still needs it back.
                    </small>
                    <div class="input-group mb-2">
                        <input ref="quickScanInput" type="text" class="form-control" v-model="quickScanCode"
                               placeholder="Scan a code — it submits automatically" @keyup.enter="submitQuickScan" :disabled="quickScanBusy">
                        <div class="input-group-append" v-if="quickScanBusy">
                            <span class="input-group-text"><span class="spinner-border spinner-border-sm"></span></span>
                        </div>
                    </div>
                    <ul class="list-unstyled small mb-0" style="max-height:260px;overflow-y:auto">
                        <li v-for="(entry, idx) in quickScanFeed" :key="idx" class="py-1 border-bottom" :class="entry.error ? 'text-danger' : ''">
                            <i class="bi" :class="entry.error ? 'bi-x-circle' : 'bi-check-circle text-primary'"></i>
                            {{ entry.message }}
                        </li>
                    </ul>
               </b-modal>
               <b-modal ref="return_items_modal" hide-footer title="Return Items">

                     <p class="text-center">You can return all Items or change the quantity to return</p>
                     <p v-if="returnItemError" class="text-danger text-center" ><small>{{ returnItemError }}</small></p>

                        <form @submit.prevent="returnItems">
                            <div class="form-group">
                                <input class="form-control" v-model="orderQtyToReturn"/>
                             </div>




                            <div class="form-group">
                                <div class="btn-group">
                                <button @click="deleteSingleOrder(orderToReturn.id)" class="btn btn-outline-primary btn-sm my-2">Return All</button>
                                <button type="submit" class="btn btn-primary btn-sm my-2">Return Items</button>
                                </div>

                            </div>
                        </form>
               </b-modal>
               <b-modal ref="createNoteModal" id="modal-5" hide-footer>
                <h5>Add Note</h5>
                <form @submit.prevent="createNote">
                    <div class="form-group">

                    <textarea class="form-control" id="exampleFormControlTextarea1" v-model="noteForm.noteText" rows="3" placeholder="Enter your note..."></textarea>
                </div>

                    <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="noteForm.addToReceipt" class="custom-control-input" id="customSwitch1">
                    <label class="custom-control-label" for="customSwitch1">Add to Receipt</label>
                    </div>


                    <div class="form-group">
                        <button class="btn btn-outline-primary btn-block btn-sm my-2">Save Note</button>
                    </div>
                </form>

                </b-modal>
               <b-modal id="re-assign-order" hide-footer>
                <h5>Select Employee to Assign</h5>

                <form @submit.prevent="reAssignOrder">
                    <div class="form-group">
                        <select class="form-control" v-model="order_to_assign.employeeToAssign">
                            <option value="null">Select Employee</option>
                            <option v-for="employee in employees" :value='employee.users.id'>{{ employee.users.name }}</option>
                        </select>

                    </div>


                    <div class="form-group">
                        <button class="btn btn-outline-primary btn-block btn-sm my-2">Save & Apply</button>
                    </div>
                </form>

                </b-modal>
                </div>




      <b-modal id="change-order-date" hide-footer>
        <div class="py-2">
            <h5>Change Orders date</h5>
            <p><small>Make sure you have selected the correct orders</small></p>
        </div>
        <date-range-picker :auto-apply="autoApply" :ranges="ranges" v-model="ordersToAction.changeOrderDatePicked" :single-date-picker=true  :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
<template #input="picker" style="width: 100% !important;">
    <p v-if="picker.startDate !==null && picker.endDate !==null">
        {{ formatDate(picker.startDate,'DD-MMM-YYYY') }}</p>
    <p v-else><i class="bi bi-calendar-event"></i> Select Date</p>
</template>
        </date-range-picker>

        <div class="text-center py-2">

            <button @click="changeOrdersDate" v-if="ordersToAction.changeOrderDatePicked.startDate !==null" class="btn btn-primary btn-sm">Move The selected Orders to - {{ formatDate(ordersToAction.changeOrderDatePicked.startDate,'DD-MMM-YYYY') }}</button>
            <button v-else  class="btn btn-primary btn-sm " disabled>Move The selected orders</button>

        </div>
      </b-modal>




        <b-modal ref="deleteconfirm_modal" id="modal-center" centered hide-footer>
            <div class="container text-center">
                <h5 class="py-4">Are you sure you want to delete this order?</h5>
                <a @click="confirmDeleteOrder"
                    class="btn btn-danger"
                    :class="{ 'disabled': !confirmIsNotComplete }"
                    :disabled="!confirmIsNotComplete">
                    Yes Delete!
                    </a>

            </div>

        </b-modal>
        <b-modal ref="undeleteconfirm_modal" id="modal-center" centered hide-footer>
            <div class="container text-center">
                <h5 class="py-4">Are you sure you want to restore this order?</h5>
                <a @click="confirmUndoOrderDeletion"
                    class="btn btn-danger"
                    :class="{ 'disabled': !confirmIsNotComplete }"
                    :disabled="!confirmIsNotComplete">
                    Yes restore!
                    </a>

            </div>

        </b-modal>
        <b-modal ref="deleteManyOrders" id="delete-many-orders" centered hide-footer>
            <div class="container text-center">
                    <h1><i class="bi bi-x-circle"></i></h1>
                <h5 class="py-4">Are you sure you want to delete these order?</h5>
            <a @click="confirmDeleteManyOrders" class="btn btn-danger">Yes Delete!</a>
            </div>

        </b-modal>
        <b-modal id="textmessage-modal" ref="textmessage_modal" hide-footer>
                <div class="text-center">
                    <h2>Send SMS to Customer</h2>
                </div>
                <form @submit.prevent="sendSMSToCustomer">

                    <div class="form-group">
                        <textarea v-if="smsForm.addMessageBody" class="form-control" v-model="smsForm.message" required>start typing</textarea>
                    </div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="smsForm.addMessageBody" type="checkbox" >
                            <label class="form-check-label" for="defaultCheck1">
                               Add a message body
                            </label>

                            </div>

                    </div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="smsForm.add0rderLink" type="checkbox" >
                            <label v-if="smsForm.addMessageBody" class="form-check-label" for="defaultCheck1">
                               Include order link
                            </label>
                            <label class="form-check-label" for="defaultCheck1">
                               Send the order link only
                            </label>
                            </div>

                    </div>
                    <div class="my-2 form-group">
                        <button v-if="smsForm.addMessageBody" type="submit" class="btn btn-block btn-outline-primary"> Send SMS</button>
                        <button v-else type="submit" class="btn btn-block btn-outline-primary"> Send Order Link</button>
                    </div>
                </form>

         </b-modal>
         <b-modal ref="customerSearch" hide-footer>
            <div class="text-center"><h5>Add Customer</h5></div>
    <div class="py-3">
                <input v-model="customerData.searchTerm" type="text" class="form-control"
                    placeholder="Search by name, email, or phone number">
                <table class="table table-striped table-sm"
                    v-if="customerData.customer.length > 0 && customerData.searchTable===true">
                    <thead>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>

                    </thead>
                    <tbody>
                        <tr v-for="customer in customerData.customer" :key="customer.id"
                            @click="customerRowSelected(customer)">
                            <td>{{ customer.full_name }}</td>
                            <td>{{ customer.phone }}</td>
                            <td>{{ customer.email }}</td>



                        </tr>
                    </tbody>

                </table>

            </div>
            <p>Can't find Customer? &nbsp;<a href="#" v-b-modal="'new_customer_form'" >Add New Customer</a></p>

  </b-modal>
  <b-modal ref="customerdetails" id="new_customer_form" hide-footer >

 <form v-on:submit.prevent="newCustomer">
     <div class="form-row py-1">
         <div class="col-12">

             <input class="form-control border-bottom"  v-model="customerform.name"  type="text" placeholder="Full Name" required/>
             <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
         </div>
     </div>
     <div class="form-group py-1">

         <input class="form-control border-bottom" name="c_email" v-model="customerform.email" type="email" placeholder="Email"/>


     </div>
     <div v-if="companySettings.enable_tims">
        <div  class="form-group py-1" >

            <input class="form-control border-bottom" name="krapin" v-model="customerform.krapin" type="text" placeholder="KRA PIN"/>
        </div>
        <div  class="form-group py-1" >

            <input class="form-control border-bottom" name="company" v-model="customerform.company" type="text" placeholder="Name of Company"/>
        </div>
    </div>
     <div class="form-group">
         <vue-tel-input :placeholder="712345678" v-model="customerform.phone"></vue-tel-input>
         <!--<input class="form-control border-bottom"   v-model="customerform.phone" type="text" placeholder="Phone Number"/>-->


     </div>

     <div class="form-group pt-3">
         <button class="btn btn-primary btn-block">Add Customer</button>
     </div>
 </form>
</b-modal>
<daily-department-sales-modal :selectedDate="dateRange.startDate" />

        <!-- Edit Payment Method Modal -->
        <b-modal ref="editPaymentModal" hide-footer title="Change Payment Method">
            <form @submit.prevent="submitChangePayment">
                <div class="form-group">
                    <label>Payment Method</label>
                    <select class="form-control" v-model="editPaymentForm.payment_type_id" required>
                        <option value="" disabled>Select payment method</option>
                        <option v-for="pm in paymentMethodOptions" :key="pm.id" :value="pm.id">
                            {{ pm.payment_method || pm.name }}{{ pm.account_label ? ' · ' + pm.account_label : pm.account_number ? ' · ' + pm.account_number : '' }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Amount</label>
                    <input type="number" step="0.01" class="form-control" v-model.number="editPaymentForm.amount" />
                </div>
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-light mr-2" @click="$refs.editPaymentModal.hide()">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="editPaymentLoading">
                        {{ editPaymentLoading ? 'Saving...' : 'Save Changes' }}
                    </button>
                </div>
            </form>
        </b-modal>

        <share-payment-link-modal ref="sharePaymentLink"></share-payment-link-modal>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import { getEcho } from '../services/echo';
    import utils from '../utils/utils';
    import format from 'date-fns/format'
    import {
        mapGetters
    } from 'vuex'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import DailyDepartmentSalesModal from './analytics/DailyDepartmentSalesModal.vue';
    export default {
        name: "AllOrders",
        components: {
            DateRangePicker,
            DailyDepartmentSalesModal
        },
        props: [
            'orderNumberUrl',
            'limitUrl',
            'hasBalanceUrl',
            'completedUrl',
            'partialUrl',
            'modeOfPaymentUrl',
            'hasDiscountUrl'
        ],
        data() {
            return {
                page: 1,
                first_page: 1,
                last_page: null,
                current_page: '',
                next_page_url: '',
                current_page_url: '',
                prev_page_url: '',
                daterange: '',
                orderQtyToReturn: 0,
                orderToReturn: '',
                returnItemError: '',
                tosearch: '',
                dateFormat: 'D-MM-YYYY',
                dateOne: '',
                dateTwo: '',
                orders: '',
                selectedorder: '',
                orderItems: '',
                order_id: '',
                customer: '',
                orderToShow: '',
                searchOrderValue: '',
                ordersource: '',
                fulfillmentStatusFilter: '',
                fulfillmentOrderId: null,
                quickScanMode: 'dispatch',
                quickScanCode: '',
                quickScanBusy: false,
                quickScanFeed: [],
                dateRange: {
                    startDate: this.getDefaultDate(),
                    endDate: this.getDefaultDate(),
                },
                smsForm: {
                    message: '',
                    add0rderLink: true,
                    addMessageBody: false
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
                isLoadingOrdersDone: false,
                confirmIsNotComplete: true,
                paymentSummary: [],
                items: [],
                userRole: 'employee',
                orderToDelete: '',
                noteForm: {
                    addToReceipt: false,
                    noteText: '',
                },
                companySettings: {},
                totalQuantity: 0,
                ordersToAction: {
                    changeToSelection: '',
                    selected: [],
                    selectMode: 'multi',
                    clickedCount: 0,
                    allSelected: false,
                    changeOrderDatePicked: {
                        startDate: null,
                    }
                },
                employees: {},
                order_to_assign: {
                    orderId: '',
                    employeeToAssign: null,
                },
                customerData: {
                    searchTerm: '',
                    filteredCustomers: '',
                    searchTable: false,
                    customer: {}
                },
                customerform: {
                    name: '',
                    phone: '',
                    email: '',
                    krapin: '',
                    company: '',
                },
                searchTimeout: '',
                sourceUrl: '',
                editPaymentForm: {
                    order_id: null,
                    leg_id: null,
                    leg_type: 'order',
                    payment_type_id: null,
                    amount: null,
                },
                editPaymentLoading: false,
                paymentMethodOptions: [],
                paymentMethodFilter: '',
                statusFilter: '',
                soldByFilter: '',
                showMoreFilters: false,
            }
        },
        computed: {
            /** Google Maps link from the customer's saved pin, else their address text. */
            customerMapUrl() {
                const c = this.customer;
                if (!c) return null;
                if (c.address_latitude && c.address_longitude) {
                    return `https://www.google.com/maps/search/?api=1&query=${c.address_latitude},${c.address_longitude}`;
                }
                if (c.address_address || c.town) {
                    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(c.full_address || [c.apartment, c.address_address, c.town].filter(Boolean).join(', '));
                }
                return null;
            },
            ...mapGetters(['userDetails']),
            isAdminOrOwner() {
                return (this.userDetails.roles || []).some(r => r.name === 'Admin' || r.name === 'owner')
            },
            canManageOrdersRole() {
                return this.isAdminOrOwner || this.hasPermission('can manage orders')
            },
            canSeeProfit() {
                return this.isAdminOrOwner || this.hasPermission('view-profit-loss')
            },
            hasChannelsEnabled() {
                return !!(this.companySettings.shopify_enabled || this.companySettings.woocommerce_enabled)
            },
            fields() {
                const baseFields = [
                    { key: '#' },
                    { key: 'order', sortable: true },
                    { key: 'created_at', label: 'Time', sortable: true },
                    { key: 'created_at', label: 'Date', sortable: true },
                    { key: 'total_amount', label: 'Amount', sortable: true },
                    { key: 'payment_method', label: 'Mode', sortable: false },
                ]
                if (!this.hasChannelsEnabled) return baseFields
                return [
                    ...baseFields,
                    { key: 'source', label: 'Channel', sortable: false },
                    { key: 'fulfillment_status', label: 'Fulfillment', sortable: false },
                ]
            },
            canDispatchOrders() {
                return this.canManageOrdersRole || this.hasPermission('view-orders')
            },
            canUseQuickDispatch() {
                return this.canDispatchOrders && !!(this.companySettings.enable_fulfillment_dispatch || this.companySettings.shopify_enabled || this.companySettings.woocommerce_enabled)
            },
            canUseQuickReturns() {
                return this.canManageOrdersRole && !!(this.companySettings.enable_fulfillment_returns || this.companySettings.shopify_enabled || this.companySettings.woocommerce_enabled)
            },
             totalQuantityComputed() {
      if (!this.orderToShow || !this.orderToShow.orders) return 0;
      return this.orderToShow.orders.reduce((sum, item) => sum + item.qty, 0);
    },


    correctSubTotal() {
      if (!this.orderToShow || !this.orderToShow.total_amount) {
        return 0;
      }

      if (!this.companySettings.enable_taxes || !this.orderToShow.tax_ledgers || this.orderToShow.tax_ledgers.length === 0) {
        return this.orderToShow.total_amount;
      }

      const totalTaxes = this.orderToShow.tax_ledgers.reduce((sum, tax) => {
        return sum + parseFloat(tax.credit || 0);
      }, 0);

      return this.orderToShow.total_amount - totalTaxes;
    },


  correctTotalProfits() {
    if (!this.orderToShow) return 0;

    // Start with backend-calculated profit
    const backendProfit = this.orderToShow.total_profit || 0;

    // If taxes enabled, subtract taxes from profit
    if (this.companySettings.enable_taxes && this.orderToShow.tax_ledgers) {
      const totalTaxes = this.orderToShow.tax_ledgers.reduce((sum, tax) => {
        return sum + parseFloat(tax.credit || 0);
      }, 0);

      return backendProfit - totalTaxes;
    }

    return backendProfit;
  },

    // Tax totals for display
    totalTaxes() {
      if (!this.orderToShow.tax_ledgers || this.orderToShow.tax_ledgers.length === 0) {
        return 0;
      }

      return this.orderToShow.tax_ledgers.reduce((sum, tax) => {
        return sum + parseFloat(tax.credit || 0);
      }, 0);
    },

        },
        mounted() {
            //
            this.current_page_url = '/api/allorders';
            // this.ordersToAction.changeToSelection = (this.$route.query['bulk-action']) ? this.$route.query['bulk-action'] : false;
            this.bulkOrdersAction();
            this.loadorderDetails();
            this.fetchEmployees();
            this.fetchPaymentMethods();
            this.getUser();
            this.setSource()
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                this.redirectToSource()
            })
            this.subscribeKds();
        },
        beforeDestroy() {
            if (this.kdsChannel) getEcho().leave(this.kdsChannel);
            clearTimeout(this.kdsRefreshTimer);
        },
        watch: {
            dateRange(after, before) {
                if (this.dateRange.startDate && this.dateRange.endDate) {
                    // Get the existing query parameters
                    const urlParams = new URLSearchParams(window.location.search);
                    // Check if the 'bulk-action' parameter exists
                    urlParams.set('start-date', this.dateRange.startDate);
                    urlParams.set('end-date', this.dateRange.endDate);
                    // Build the new URL with the updated query parameters
                    const newURL = '/orders?' + urlParams.toString();
                    // Redirect to the new URL
                    window.location.replace(newURL);
                }
            },
            'customerData.searchTerm': function() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.customerData.searchTable = true
                    this.getCustomers();
                }, 500); // Debounce delay (500ms)
            },
        userDetails: {
            immediate: true,
            handler(val) {
                if (val?.company?.companysettings) {
                    this.companySettings = val.company.companysettings;
                }
            }
        }
        },
        methods: {
            // Kitchen status dots refresh the moment a chef acts, instead of
            // only on page reload. Debounced: a chef tapping several items
            // in a row triggers one list refetch.
            subscribeKds() {
                let companyId = null;
                try {
                    const userDetails = JSON.parse(window.localStorage.getItem('userDetails'));
                    if (!userDetails?.company?.companysettings?.has_kds) return;
                    companyId = userDetails.company.id;
                } catch (e) { return; }
                if (!companyId) return;

                this.kdsChannel = `company.${companyId}.kds`;
                getEcho().private(this.kdsChannel).listen('.kds.changed', () => {
                    clearTimeout(this.kdsRefreshTimer);
                    this.kdsRefreshTimer = setTimeout(() => this.displayOrders(), 500);
                });
            },
            async fetchEmployees() {
                try {
                    this.employees = await utils.fetchEmployees()
                } catch (e) {

                }
            },

    calculateItemProfit(orderItem) {
      if (!orderItem.product && !orderItem.grouped_inventory) return 0;

      let sellingPrice = 0;
      let costPrice = 0;
      const qty = orderItem.qty || 0;

      // Get selling price and cost
      if (orderItem.product) {
        sellingPrice = orderItem.is_retail === 1
          ? (orderItem.selling_price !== null ? orderItem.selling_price : orderItem.product.ppu)
          : (orderItem.selling_price !== null ? orderItem.selling_price : orderItem.product.wholesale_sp);

        costPrice = orderItem.product.cost_price || orderItem.product.buying_price || 0;
      } else if (orderItem.grouped_inventory) {
        sellingPrice = orderItem.is_retail === 1
          ? (orderItem.selling_price !== null ? orderItem.selling_price : orderItem.grouped_inventory.cost)
          : (orderItem.selling_price !== null ? orderItem.selling_price : orderItem.grouped_inventory.wholesale);

        costPrice = orderItem.grouped_inventory.cost_price || 0;
      }

      const grossRevenue = sellingPrice * qty;
      let netRevenue = grossRevenue;

      if (this.companySettings.enable_taxes) {
        const taxRate = this.getItemTaxRate(orderItem);
        netRevenue = grossRevenue / (1 + taxRate);
      }

      const cogs = costPrice * qty;
      const profit = netRevenue - cogs;

      return profit;
    },


    getItemTaxRate(orderItem) {
      // Kenya default: Catering Levy (2%) + VAT (16%)
      // Combined: (1 + 0.02) × (1 + 0.16) - 1 = 0.1832
      return 0.1832;
    },

 getDefaultDate() {
                const date = new Date();
                return date.toISOString().split('T')[0];
            },
getDisplayProfit(orderItem) {
    if (!this.companySettings.enable_taxes) {
      return orderItem.profits || 0;
    }


    // Get backend profit for this item
    const itemProfit = orderItem.profits || 0;

    // Calculate this item's proportion of total
    const itemTotal = this.getItemTotal(orderItem);
    const orderTotal = this.orderToShow.total_amount || 1;
    const proportion = itemTotal / orderTotal;

    // Subtract proportional taxes
    const totalTaxes = this.totalTaxes || 0;
    const itemTaxes = totalTaxes * proportion;

    return itemProfit - itemTaxes;
  },
    getItemTotal(orderItem) {
    const qty = orderItem.qty || 0;

    if (orderItem.is_retail === 1) {
      if (orderItem.product) {
        return qty * ((orderItem.selling_price !== null) ? orderItem.selling_price : orderItem.product.ppu);
      } else {
        return qty * (orderItem.grouped_inventory ? orderItem.grouped_inventory.cost : 0);
      }
    } else {
      if (orderItem.product) {
        return qty * ((orderItem.selling_price !== null) ? orderItem.selling_price : orderItem.product.wholesale_sp);
      } else {
        return qty * (orderItem.grouped_inventory ? orderItem.grouped_inventory.wholesale : 0);
      }
    }
  },
    gettotalTaxes() {
    if (!this.orderToShow.tax_ledgers || this.orderToShow.tax_ledgers.length === 0) {
      return 0;
    }
    return this.orderToShow.tax_ledgers.reduce((sum, tax) => {
      return sum + parseFloat(tax.credit || 0);
    }, 0);
  },
            // Returns the best available validation record for a single-payment order.
            // Prefers order-level (final_orders.transaction_validated, set by legacy/cascade
            // path), then falls back to the first payment leg's transaction_validated so that
            // orders validated directly via the payments table are also surfaced.
            getOrderValidation(order) {
                if (order.transaction_validated) {
                    return {
                        transaction_validated:     order.transaction_validated,
                        payment_validation_status: order.payment_validation_status,
                        payment_validated_at:      order.payment_validated_at,
                        payment_validation_method: order.payment_validation_method,
                    };
                }
                const legs = this.getOrderPaymentLegs(order);
                if (legs.length > 0 && legs[0].transaction_validated) {
                    return {
                        transaction_validated:     legs[0].transaction_validated,
                        payment_validation_status: legs[0].payment_validation_status,
                        payment_validated_at:      null,
                        payment_validation_method: null,
                    };
                }
                // Status only (override / skip — no linked transaction)
                const status = order.payment_validation_status
                    || (legs.length > 0 ? legs[0].payment_validation_status : null);
                if (status && status !== 'not_required') {
                    return { transaction_validated: null, payment_validation_status: status, payment_validated_at: null, payment_validation_method: null };
                }
                return null;
            },

            // Older BNPL deposits were recorded under the "Buy Now Pay Later" payment
            // type itself rather than the real method used to collect the deposit
            // (fixed going forward in checkout). Relabel those for display only.
            relabelBnplLeg(label) {
                return (label && label.toLowerCase() === 'buy now pay later') ? 'Deposit' : label;
            },
            // Returns a normalised list of payment legs for display.
            // Prefers the new `payments` table (available after backfill / dual-write);
            // falls back to legacy `splitorderpayment` for pre-migration orders.
            getOrderPaymentLegs(order) {
                // Only completed payments represent real money that actually
                // moved - pending/failed/superseded STK attempts (e.g. a
                // customer retrying an interrupted Dukakit link payment) must
                // not render as extra "modes" for the order. Gate on the
                // FILTERED length, not the raw one - an order whose only
                // `payments` rows are non-completed must still fall through
                // to the splitorderpayment legs below (e.g. an older BNPL
                // deposit, or any other legitimately-recorded leg), not
                // silently render nothing.
                const completedPayments = (order.payments || []).filter(p => p.status === 'completed');
                if (completedPayments.length > 0) {
                    return completedPayments.map(p => ({
                        id:                        p.id,
                        leg_type:                  'payment',
                        payment_method:            this.relabelBnplLeg((() => {
                                                        const txSender = p.transaction_validated && p.transaction_validated.sms_message && p.transaction_validated.sms_message.sender;
                                                        if (txSender) return txSender;
                                                        const pt = p.payment_type && p.payment_type.payment_method;
                                                        if (pt && pt !== 'wallet') return pt;
                                                        if (p.reference && p.reference.startsWith('WALLET-')) return 'wallet';
                                                        if (pt) return pt;
                                                        return 'Unknown';
                                                    })()),
                        payment_type_id:           p.payment_type_id,
                        paid_amount:               p.amount,
                        payment_validation_status: p.payment_validation_status,
                        transaction_validated:     p.transaction_validated,
                        created_at:                p.created_at,
                    }));
                }
                if (order.splitorderpayment && order.splitorderpayment.length > 0) {
                    return order.splitorderpayment.map(s => ({
                        id:                        s.id,
                        leg_type:                  'split',
                        payment_method:            this.relabelBnplLeg((s.paymentmethod && s.paymentmethod.payment_method) || 'Unknown'),
                        payment_type_id:           s.payment_type_id,
                        paid_amount:               s.paid_amount,
                        payment_validation_status: null,
                        transaction_validated:     null,
                        created_at:                s.created_at,
                    }));
                }
                return [];
            },
            getPaymentBadgeClass(method) {
            if (!method) return 'badge-dark' // handle null/undefined safely

            const pMethod = method.toLowerCase().trim()

            switch (pMethod) {
                case 'cash':
                return 'badge-secondary'

                case 'm-pesa':
                case 'mpesa':
                return 'badge-success'

                case 'card':
                case 'cards':
                return 'badge-primary'

                case 'bank':
                return 'badge-info'

                case 'wallet':
                return 'badge-warning'

                default:
                return 'badge-dark'
            }
            },

            validationStatusClass(status) {
                const map = {
                    pending:    'badge-warning',
                    validated:  'badge-success',
                    override:   'badge-info',
                };
                return map[status] || 'badge-secondary';
            },

            validationStatusLabel(status) {
                const map = {
                    pending:    'Pending Validation',
                    validated:  'Validated',
                    override:   'Override',
                };
                return map[status] || status;
            },

            setSource() {
                const urlParams = new URLSearchParams(window.location.search);
                this.sourceUrl = urlParams.get('source');
            },
            customerRowSelected(customer) {
                this.assignOrderToCustomer(customer.id, this.orderToShow.id);
            },
            redirectToSource() {
                const urlParams = new URLSearchParams(window.location.search);
                const source = urlParams.get('source');
                if (source) {
                    // Redirect to the source URL
                    window.location.href = source;
                }
            },
            markOrderasVerified(orderId) {
                axios.post('/api/verify-order', {
                    orderId: orderId
                }).
                then(result => {
                    if (result.status === 200) {
                        window.location.reload()
                    }
                }).catch(error => {
                    console.error('Error:', error);
                    if (error.response) {
                        console.error('Response Data:', error.response.data);
                        console.error('Status:', error.response.status);
                        console.error('Headers:', error.response.headers);
                    } else if (error.request) {
                        console.error('Request:', error.request);
                    } else {
                        console.error('Error Message:', error.message);
                    }
                });
            },
            newCustomer() {
                axios.post('/api/newcustomer', {
                    phone_no: this.customerform.phone,
                    email: this.customerform.email,
                    f_name: this.customerform.name,
                    krapin: this.customerform.krapin
                }).
                then(result => {
                    // now send message to customer
                    this.$refs['customerdetails'].hide();
                    this.assignOrderToCustomer(result.data.customer_id, this.orderToShow.id);
                    this.$refs['customerSearch'].hide();
                }).catch();
            },
            assignOrderToCustomer(customerId, orderId) {
                axios.put('/api/order-details', {
                    order_id: orderId,
                    customer_id: customerId,
                }).then(result => {
                    if (result.status === 200) {
                        this.$toasts.push({
                            'type': "success",
                            "message": "Customer added successfully"
                        })
                        this.$refs.customerSearch.hide()
                    }
                });
            },
            customerModalOpen() {
                this.getCustomers();
                this.$refs.customerSearch.show()
            },
            getCustomers() {
                axios.get(`/api/allcustomers?search=${this.customerData.searchTerm}`)
                    .then(result => {
                        this.customerData.customer = result.data.data;
                    });
            },
            reAssignOrder() {
                axios.post('/api/re-assign-order', { ...this.order_to_assign
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            deleteSingleOrder(id) {
                axios.post('/api/remove-item-from-order', {
                    orderItemId: id
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            returnItems() {
                axios.post('/api/remove-item-from-order', {
                    orderItemId: this.orderToReturn.id,
                    qty:this.orderQtyToReturn
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {
                    this.returnItemError = error.response?.data?.message || "Could not return the items. Check your connection and try again."
                })
            },
            returnItemsModal(order) {
                this.orderToReturn = order,
                this.orderQtyToReturn = order.qty,
                this.$refs.return_items_modal.show()
            },
            async markKDSItemAsDone(id) {
                await axios.post('/api/update-kds-order-item', {
                    orderItemId: id,
                    orderId: this.orderToShow.id,
                    orderItems: this.orderToShow.orders
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            async sendItemToKitchen(id) {
                await axios.post('/api/update-kds-order-item', {
                    orderItemId: id
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            onRowClicked(items) {
                this.$refs.orderDetailsModal.show()
                this.orderDetails(items.id);
            },
            ordersRowClass(items) {
                if (items.deleted_at !== null) {
                    return 'table-danger'
                }
            },

            convertToInternational(number) {
                // Assuming the local number starts with '0' and has 10 digits
                if (number.startsWith('0') && number.length === 10) {
                    return '254' + number.substring(1);
                } else {
                    return number
                }
            },
            // Mirrors OrdersController::canRemoveFrom: unpaid orders need delete-orders,
            // paid or part-paid ones are voids and need void-orders.
            canRemoveFrom(order) {
                if (!order) return false
                if (this.canManageOrdersRole || this.hasPermission('void-orders')) return true
                const unpaid = Number(order.status) === 0 && Number(order.partial) === 0
                return unpaid && this.hasPermission('delete-orders')
            },
            hasPermission(permissionName) {
                const perms = this.userDetails?.permissions;
                if (!Array.isArray(perms)) return false;
                return perms.some(p => p.name === permissionName);
            },
            withDeletedOrders(btnClick = false) {
                if (btnClick) {
                    const urlParams = new URLSearchParams(window.location.search);
                    if (urlParams.has('withTrashed')) {
                        // The parameter exists but is not equal to 'true'
                    } else {
                        urlParams.set('withTrashed', '1'); // Set the parameter to '1'
                        const newURL = `${window.location.pathname}?${urlParams.toString()}`;
                        window.location.replace(newURL);
                        this.displayOrders()
                    }
                }
            },
            bulkOrdersAction() {
                // Get the URL query parameters
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                if (urlParams.has('bulk-action')) {
                    // Get the value of the 'bulk-action' parameter
                    const bulkActionValue = urlParams.get('bulk-action');
                    if (bulkActionValue !== null || bulkActionValue !== '') {
                        if (bulkActionValue === 'true') {
                            this.ordersToAction.changeToSelection = true
                        }
                        if (bulkActionValue === 'false') {
                            this.ordersToAction.changeToSelection = false
                        }
                    } else {
                        window.location.replace('/orders')
                    }
                } else {
                    this.ordersToAction.changeToSelection = false
                }
            },
            switchOrdersAction() {
                // Get the existing query parameters
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                const bulkActionValue = urlParams.get('bulk-action');
                const newBulkActionValue = bulkActionValue === 'true' ? 'false' : 'true';
                // Update the 'bulk-action' parameter in the query
                urlParams.set('bulk-action', newBulkActionValue);
                // Build the new URL with the updated query parameters
                const newURL = '/orders?' + urlParams.toString();
                // Redirect to the new URL
                window.location.replace(newURL);
            },
            onRowSelected(items) {
                this.ordersToAction.selected = items
            },
            async changeOrdersDate() {
                await axios.post('/api/change-orders-date', { ...this.ordersToAction
                }).then(
                    results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }
                ).catch()
            },
            async confirmDeleteManyOrders() {
                await axios.post('/api/delete-many-orders', { ...this.ordersToAction
                }).then(
                    results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }
                ).catch()
            },
            selectAllRows() {
                this.$refs.selectableTable.selectAllRows()
                this.ordersToAction.allSelected = true;
            },
            clearSelected() {
                this.$refs.selectableTable.clearSelected()
            },
            completeSearchOrderValue(after, before) {
                this.displayOrders();
            },
            sendSMSToCustomer() {
                if (this.smsForm.message !== '' || this.smsForm.add0rderLink) {
                    axios.post('/api/send-sms-to-customer', {
                        customer: this.customer,
                        message: (this.smsForm.add0rderLink) ? this.smsForm.message + '\n' + this.$platformBrand.appUrl + '/customer-order-view/' + this.orderToShow.id : this.smsForm.message,
                    }).then(results => {
                        if (results.delivery === 'success') {
                            this.$toasts.push({
                                'type': "success",
                                "message": "Message sent successfully"
                            })
                        }
                        this.$refs.textmessage_modal.hide()
                    })
                } else {
                    this.$toasts.push({
                        'type': "error",
                        "message": "You need to add a message or send link only"
                    })
                }
            },
            createNote() {
                axios.post('/api/add-note-to-order', { ...this.noteForm,
                    orderId: this.orderToShow.id
                }).then(results => {
                    if (results.status === 200)
                        this.$refs.createNoteModal.hide()
                    this.orderDetails(this.orderToShow.id)
                })
            },
            deleteOrderNote(noteId) {
                axios.delete('/api/delete-note/' + noteId).then(results => {
                    if (results.status === 200)
                        this.orderDetails(this.orderToShow.id)
                })
            },
            getUser() {
                this.userRole = this.userDetails.roles?.[0]?.name
            },
            deleteOrderConfirm(order) {
                this.orderToDelete = order
                this.$refs.deleteconfirm_modal.show()
            },
            unDeleteOrderConfirm(order) {
                this.orderToDelete = order
                this.$refs.undeleteconfirm_modal.show()
            },
            async confirmDeleteOrder() {
                this.confirmIsNotComplete = false
                await axios.delete("/api/delete-order/" + this.orderToDelete.id)
                    .then(results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }).catch(errors => {})
            },
            async confirmUndoOrderDeletion() {
                this.confirmIsNotComplete = false
                await axios.delete("/api/un-delete-order/" + this.orderToDelete.id)
                    .then(results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }).catch(errors => {})
            },
            displayOrders() {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get(this.current_page_url, {
                        params: {
                            'source': this.ordersource,
                            'fulfillment_status': this.fulfillmentStatusFilter,
                            'search': this.searchOrderValue,
                            startdate: this.dateRange.startDate,
                            enddate: this.dateRange.endDate,
                            limit: (this.limitUrl) ? this.limitUrl : '',
                            completed: (this.completedUrl) ? this.completedUrl : '',
                            partial: (this.partialUrl) ? this.partialUrl : '',
                            has_balance: (this.hasBalanceUrl) ? this.hasBalanceUrl : '',
                            has_discount: (this.hasDiscountUrl) ? this.hasDiscountUrl : '',
                            withTrashed: (urlParams.has('withTrashed')) ? 1 : 0,
                            unattended: (urlParams.has('un-attended')) ? urlParams.get('un-attended') : 0,
                            payment_method: this.paymentMethodFilter,
                            status: this.statusFilter,
                            sold_by: this.soldByFilter,
                        }
                    })
                    .then(result => {
                        this.last_page = result.data.orders.last_page_url;
                        this.current_page = result.data.orders.current_page;
                        this.next_page_url = result.data.orders.next_page_url;
                        this.prev_page_url = result.data.orders.prev_page_url;
                        this.orders = result.data.orders.data;
                        // let orderItems = [];
                        // $.each(result.data.data, function(key, value) {
                        //     let paymentMethods = [];
                        //     if (value.status && value.partial) {
                        //         if (value.splitorderpayment.length > 0) {
                        //             $.each(value.splitorderpayment, function(key, value) {
                        //                 paymentMethods.push(value.paymentmethod.payment_method)
                        //             })
                        //         } else {
                        //             paymentMethods.push(value.paymentmethod.payment_method)
                        //         }
                        //     } else if (!value.status && value.partial) {
                        //         $.each(value.splitorderpayment, function(key, value) {
                        //             paymentMethods.push(value.paymentmethod.payment_method)
                        //         })
                        //     } else if (value.status && !value.partial) {
                        //         paymentMethods.push(value.paymentmethod.payment_method)
                        //     }
                        //     orderItems.push({
                        //         "id": value.id,
                        //         "order": value.order,
                        //         "date": moment(value.created_at).format('DD-MM-YYYY'),
                        //         "time": moment(value.created_at).format('hh:mm A'),
                        //         "amount": value.total_amount,
                        //         "modes": paymentMethods,
                        //         status: value.status,
                        //         is_verified: value.is_verified,
                        //         deleted_at:value.deleted_at
                        //     });
                        // });
                        this.items = result.data.orders.data;
                        this.paymentSummary = result.data.totals;
                        // let orderssize = result.data.data.length - 1;
                        this.isLoadingOrdersDone = true
                        // this.orderDetails(this.orders[orderssize].id);
                    }).catch(error => {});
            },
            nextPage() {
                this.current_page_url = this.next_page_url;
                this.displayOrders();
                // let orderssize = result.data.length - 1;
            },
            prevPage() {
                this.current_page_url = this.prev_page_url;
                this.displayOrders();
            },
            sourceLabel(source) {
                return ({0: 'POS', 1: 'WooCommerce', 2: 'Shopify', 3: 'Payment Link'})[source] ?? 'POS';
            },
            sourceBadgeClass(source) {
                return ({0: 'badge-secondary', 1: 'badge-dark', 2: 'badge-primary', 3: 'badge-primary'})[source] ?? 'badge-secondary';
            },
            // Street · town of the order's customer, shown small under the fulfillment badge.
            orderAddressLine(order) {
                const c = order && order.customer;
                if (!c) return '';
                return [c.address_address, c.town].map(v => (v || '').trim()).filter(Boolean).join(' · ');
            },
            fulfillmentLabel(status) {
                return ({
                    not_released: 'Not Released', packing: 'Packing', partially_dispatched: 'Partially Dispatched',
                    dispatched: 'Dispatched', delivered: 'Delivered', returned: 'Returned',
                    partially_returned: 'Partially Returned', cancelled: 'Cancelled',
                })[status] ?? 'Not Released';
            },
            fulfillmentBadgeClass(status) {
                return ({
                    not_released: 'badge-dark', packing: 'badge-secondary', partially_dispatched: 'badge-dark',
                    dispatched: 'badge-primary', delivered: 'badge-primary', returned: 'badge-danger',
                    partially_returned: 'badge-danger', cancelled: 'badge-secondary',
                })[status] ?? 'badge-dark';
            },
            canPackDispatch(order) {
                if (!order) return false
                if (!this.canDispatchOrders) return false
                // Shopify/WooCommerce orders always use Pack / Dispatch — it's the
                // only event that deducts their inventory. POS orders (source 0)
                // are opt-in via Settings → Inventory → "Enable Pack / Dispatch".
                if (order.source === 1 || order.source === 2) return true
                if (order.source === 0) {
                    return !!(this.companySettings.enable_fulfillment_dispatch || this.companySettings.shopify_enabled || this.companySettings.woocommerce_enabled)
                }
                return false
            },
            openPackDispatch(orderId) {
                this.fulfillmentOrderId = orderId
                this.$refs.packDispatchModal.show()
            },
            onPackDispatchUpdated({ orderId, fulfillment_status }) {
                if (this.orderToShow && this.orderToShow.id === orderId) {
                    this.orderToShow.fulfillment_status = fulfillment_status
                }
                this.displayOrders()
            },
            openQuickScan(mode) {
                this.quickScanMode = mode
                this.quickScanCode = ''
                this.quickScanFeed = []
                this.$refs.quickScanModal.show()
            },
            focusQuickScanInput() {
                this.$nextTick(() => this.$refs.quickScanInput && this.$refs.quickScanInput.focus())
            },
            submitQuickScan() {
                const code = (this.quickScanCode || '').trim()
                if (!code || this.quickScanBusy) return
                this.quickScanCode = ''
                this.quickScanBusy = true

                const url = this.quickScanMode === 'dispatch'
                    ? '/api/integrations/fulfillment/scan'
                    : '/api/integrations/returns/scan'

                axios.post(url, { code })
                    .then(({ data }) => {
                        const verb = this.quickScanMode === 'dispatch' ? 'Dispatched' : 'Returned'
                        this.quickScanFeed.unshift({
                            message: `${verb} on order ${data.order || '—'} — ${data.fulfillment_status ? this.fulfillmentLabel(data.fulfillment_status) : ''}`,
                        })
                    })
                    .catch(err => {
                        const errors = err.response?.data?.errors
                        const specific = errors && Object.values(errors)[0]?.[0]
                        this.quickScanFeed.unshift({ error: true, message: specific || err.response?.data?.message || `Could not resolve "${code}".` })
                    })
                    .finally(() => {
                        this.quickScanBusy = false
                        this.displayOrders()
                        this.focusQuickScanInput()
                    })
            },
            loadorderDetails() {
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                if (urlParams.has('start-date') && urlParams.has('end-date')) {
                    this.dateRange.startDate = moment.utc(urlParams.get('start-date')).startOf('day').toISOString();
                    this.dateRange.endDate = moment.utc(urlParams.get('end-date')).endOf('day').toISOString();
                }
                if (this.orderNumberUrl) {
                    this.$refs.orderDetailsModal.show()
                    // The Ledger's "open full order" link passes the
                    // FinalOrder id here (not the human order number),
                    // since that's what it already has on hand — reuse the
                    // same id-based lookup a row click uses.
                    this.orderDetails(this.orderNumberUrl);
                }
                this.displayOrders();
            },
            orderDetailsByOrderNumber(order) {
                axios.get('/api/order-details', {
                        params: {
                            order_number: order
                        }
                    })
                    .then(result => {
                        this.orderToShow = result.data.order;
                        this.customer = result.data.customer;
                        // this.orderItems = result.data.orderitems;
                        this.totalQuantity = this.orderToShow.orders.reduce((accumulator, item) => accumulator + item.qty, 0);
                        // on click scroll back to top
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    });
            },
            orderDetails(order_id) {
                axios.get('/api/order-details', {
                        params: {
                            order_id: order_id
                        }
                    })
                    .then(result => {
                        this.orderToShow = result.data.order;
                        this.customer = result.data.customer;
                        // this.orderItems = result.data.orderitems;
                        this.totalQuantity = this.orderToShow.orders.reduce((accumulator, item) => accumulator + item.qty, 0);
                        // on click scroll back to top
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    });
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                this.daterange = formattedDates;
                return formattedDates
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
            getStatusColor(status) {
                switch (status) {
                    case 'pending':     return 'text-secondary';
                    case 'in_progress': return 'text-primary';
                    case 'done':        return 'text-success';
                    case 'cancelled':   return 'text-danger';
                    default:            return 'text-muted';
                }
            },

            canManagePayments() {
                return this.userRole === 'Admin' || this.hasPermission('can manage orders');
            },

            async fetchPaymentMethods() {
                if (this.paymentMethodOptions.length) return;
                try {
                    const { data } = await axios.get('/api/payments');
                    this.paymentMethodOptions = (Array.isArray(data) ? data : []).filter(p => p.enabled);
                } catch (e) {
                    console.error('fetchPaymentMethods', e);
                }
            },

            openEditPaymentModal(leg) {
                this.editPaymentForm = {
                    order_id:        this.orderToShow.id,
                    leg_id:          leg ? leg.id : null,
                    leg_type:        leg ? leg.leg_type : 'order',
                    payment_type_id: leg ? (leg.payment_type_id || null) : (this.orderToShow.payment_types_id || null),
                    amount:          leg ? leg.paid_amount : this.orderToShow.total_amount,
                };
                this.fetchPaymentMethods();
                this.$refs.editPaymentModal.show();
            },

            async submitChangePayment() {
                if (!this.editPaymentForm.payment_type_id) return;
                this.editPaymentLoading = true;
                try {
                    await axios.put('/api/change-order-payment', { ...this.editPaymentForm });
                    this.$toasts.push({ type: 'success', message: 'Payment method updated' });
                    this.$refs.editPaymentModal.hide();
                    this.orderDetails(this.orderToShow.id);
                } catch (e) {
                    this.$toasts.push({ type: 'error', message: e.response?.data?.message || 'Failed to update payment' });
                } finally {
                    this.editPaymentLoading = false;
                }
            },
        },
    }
</script>

<style scoped>
    .table-orders .order-to-click {
        color: #171717;
        font-size: 13.5px;
        font-weight: 500;
    }
    .table-orders .order-to-click:hover {
        cursor: wait;
    }
    .circle-icon-danger {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #e3342f solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }
    .circle-icon-warning {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #000 solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }
    .circle-icon-success {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #38c172 solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }


/* For Vue 2 scoped styles, use >>> instead of :deep() */
>>> .modal-body {
  overflow: visible !important;
}
>>> .modal-content {
  overflow: visible !important;
}
</style>
